// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file artifacts/store/v1/store_service.proto (package artifacts.store.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { DocumentSource } from "../../v1/model_pb";
import { file_artifacts_v1_model } from "../../v1/model_pb";
import type { Platform } from "../../../companycatalog/v1/company_catalog_pb";
import { file_companycatalog_v1_company_catalog } from "../../../companycatalog/v1/company_catalog_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file artifacts/store/v1/store_service.proto.
 */
export const file_artifacts_store_v1_store_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_artifacts_v1_model, file_companycatalog_v1_company_catalog]);

/**
 * @generated from message artifacts.store.v1.UpdateArtifactSubcategoryRequest
 */
export type UpdateArtifactSubcategoryRequest = Message<"artifacts.store.v1.UpdateArtifactSubcategoryRequest"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: string sub_category_id = 2;
   */
  subCategoryId: string;
};

/**
 * Describes the message artifacts.store.v1.UpdateArtifactSubcategoryRequest.
 * Use `create(UpdateArtifactSubcategoryRequestSchema)` to create a new message.
 */
export const UpdateArtifactSubcategoryRequestSchema: GenMessage<UpdateArtifactSubcategoryRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 0);

/**
 * @generated from message artifacts.store.v1.UpdateArtifactSubcategoryResponse
 */
export type UpdateArtifactSubcategoryResponse = Message<"artifacts.store.v1.UpdateArtifactSubcategoryResponse"> & {
};

/**
 * Describes the message artifacts.store.v1.UpdateArtifactSubcategoryResponse.
 * Use `create(UpdateArtifactSubcategoryResponseSchema)` to create a new message.
 */
export const UpdateArtifactSubcategoryResponseSchema: GenMessage<UpdateArtifactSubcategoryResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 1);

/**
 * @generated from message artifacts.store.v1.SetArtifactMisclassificationRequest
 */
export type SetArtifactMisclassificationRequest = Message<"artifacts.store.v1.SetArtifactMisclassificationRequest"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: bool is_misclassified = 2;
   */
  isMisclassified: boolean;
};

/**
 * Describes the message artifacts.store.v1.SetArtifactMisclassificationRequest.
 * Use `create(SetArtifactMisclassificationRequestSchema)` to create a new message.
 */
export const SetArtifactMisclassificationRequestSchema: GenMessage<SetArtifactMisclassificationRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 2);

/**
 * @generated from message artifacts.store.v1.SetArtifactMisclassificationResponse
 */
export type SetArtifactMisclassificationResponse = Message<"artifacts.store.v1.SetArtifactMisclassificationResponse"> & {
};

/**
 * Describes the message artifacts.store.v1.SetArtifactMisclassificationResponse.
 * Use `create(SetArtifactMisclassificationResponseSchema)` to create a new message.
 */
export const SetArtifactMisclassificationResponseSchema: GenMessage<SetArtifactMisclassificationResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 3);

/**
 * @generated from message artifacts.store.v1.DeleteOrgArtifactRequest
 */
export type DeleteOrgArtifactRequest = Message<"artifacts.store.v1.DeleteOrgArtifactRequest"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;
};

/**
 * Describes the message artifacts.store.v1.DeleteOrgArtifactRequest.
 * Use `create(DeleteOrgArtifactRequestSchema)` to create a new message.
 */
export const DeleteOrgArtifactRequestSchema: GenMessage<DeleteOrgArtifactRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 4);

/**
 * @generated from message artifacts.store.v1.DownloadOrgArtifactRequest
 */
export type DownloadOrgArtifactRequest = Message<"artifacts.store.v1.DownloadOrgArtifactRequest"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;
};

/**
 * Describes the message artifacts.store.v1.DownloadOrgArtifactRequest.
 * Use `create(DownloadOrgArtifactRequestSchema)` to create a new message.
 */
export const DownloadOrgArtifactRequestSchema: GenMessage<DownloadOrgArtifactRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 5);

/**
 * @generated from message artifacts.store.v1.DownloadOrgArtifactResponse
 */
export type DownloadOrgArtifactResponse = Message<"artifacts.store.v1.DownloadOrgArtifactResponse"> & {
  /**
   * @generated from field: bytes file_content = 1;
   */
  fileContent: Uint8Array;
};

/**
 * Describes the message artifacts.store.v1.DownloadOrgArtifactResponse.
 * Use `create(DownloadOrgArtifactResponseSchema)` to create a new message.
 */
export const DownloadOrgArtifactResponseSchema: GenMessage<DownloadOrgArtifactResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 6);

/**
 * @generated from message artifacts.store.v1.DeleteOrgArtifactResponse
 */
export type DeleteOrgArtifactResponse = Message<"artifacts.store.v1.DeleteOrgArtifactResponse"> & {
};

/**
 * Describes the message artifacts.store.v1.DeleteOrgArtifactResponse.
 * Use `create(DeleteOrgArtifactResponseSchema)` to create a new message.
 */
export const DeleteOrgArtifactResponseSchema: GenMessage<DeleteOrgArtifactResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 7);

/**
 * @generated from message artifacts.store.v1.DownloadArtifactBundleRequest
 */
export type DownloadArtifactBundleRequest = Message<"artifacts.store.v1.DownloadArtifactBundleRequest"> & {
  /**
   * @generated from field: repeated string artifact_ids = 1;
   */
  artifactIds: string[];

  /**
   * @generated from field: repeated string revision_ids = 2;
   */
  revisionIds: string[];
};

/**
 * Describes the message artifacts.store.v1.DownloadArtifactBundleRequest.
 * Use `create(DownloadArtifactBundleRequestSchema)` to create a new message.
 */
export const DownloadArtifactBundleRequestSchema: GenMessage<DownloadArtifactBundleRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 8);

/**
 * DownloadArtifactBundleResponse is one chunk of the zip. The archive is the
 * concatenation of every chunk's bytes, in order; the client reassembles it.
 *
 * @generated from message artifacts.store.v1.DownloadArtifactBundleResponse
 */
export type DownloadArtifactBundleResponse = Message<"artifacts.store.v1.DownloadArtifactBundleResponse"> & {
  /**
   * @generated from field: bytes chunk = 1;
   */
  chunk: Uint8Array;
};

/**
 * Describes the message artifacts.store.v1.DownloadArtifactBundleResponse.
 * Use `create(DownloadArtifactBundleResponseSchema)` to create a new message.
 */
export const DownloadArtifactBundleResponseSchema: GenMessage<DownloadArtifactBundleResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 9);

/**
 * @generated from message artifacts.store.v1.GetArtifactPreviewUrlRequest
 */
export type GetArtifactPreviewUrlRequest = Message<"artifacts.store.v1.GetArtifactPreviewUrlRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message artifacts.store.v1.GetArtifactPreviewUrlRequest.
 * Use `create(GetArtifactPreviewUrlRequestSchema)` to create a new message.
 */
export const GetArtifactPreviewUrlRequestSchema: GenMessage<GetArtifactPreviewUrlRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 10);

/**
 * @generated from message artifacts.store.v1.GetArtifactPreviewUrlResponse
 */
export type GetArtifactPreviewUrlResponse = Message<"artifacts.store.v1.GetArtifactPreviewUrlResponse"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message artifacts.store.v1.GetArtifactPreviewUrlResponse.
 * Use `create(GetArtifactPreviewUrlResponseSchema)` to create a new message.
 */
export const GetArtifactPreviewUrlResponseSchema: GenMessage<GetArtifactPreviewUrlResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 11);

/**
 * @generated from message artifacts.store.v1.GetArtifactDownloadUrlRequest
 */
export type GetArtifactDownloadUrlRequest = Message<"artifacts.store.v1.GetArtifactDownloadUrlRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message artifacts.store.v1.GetArtifactDownloadUrlRequest.
 * Use `create(GetArtifactDownloadUrlRequestSchema)` to create a new message.
 */
export const GetArtifactDownloadUrlRequestSchema: GenMessage<GetArtifactDownloadUrlRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 12);

/**
 * @generated from message artifacts.store.v1.GetArtifactDownloadUrlResponse
 */
export type GetArtifactDownloadUrlResponse = Message<"artifacts.store.v1.GetArtifactDownloadUrlResponse"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message artifacts.store.v1.GetArtifactDownloadUrlResponse.
 * Use `create(GetArtifactDownloadUrlResponseSchema)` to create a new message.
 */
export const GetArtifactDownloadUrlResponseSchema: GenMessage<GetArtifactDownloadUrlResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 13);

/**
 * @generated from message artifacts.store.v1.GetArtifactRevisionPreviewUrlRequest
 */
export type GetArtifactRevisionPreviewUrlRequest = Message<"artifacts.store.v1.GetArtifactRevisionPreviewUrlRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message artifacts.store.v1.GetArtifactRevisionPreviewUrlRequest.
 * Use `create(GetArtifactRevisionPreviewUrlRequestSchema)` to create a new message.
 */
export const GetArtifactRevisionPreviewUrlRequestSchema: GenMessage<GetArtifactRevisionPreviewUrlRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 14);

/**
 * @generated from message artifacts.store.v1.GetArtifactRevisionPreviewUrlResponse
 */
export type GetArtifactRevisionPreviewUrlResponse = Message<"artifacts.store.v1.GetArtifactRevisionPreviewUrlResponse"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message artifacts.store.v1.GetArtifactRevisionPreviewUrlResponse.
 * Use `create(GetArtifactRevisionPreviewUrlResponseSchema)` to create a new message.
 */
export const GetArtifactRevisionPreviewUrlResponseSchema: GenMessage<GetArtifactRevisionPreviewUrlResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 15);

/**
 * @generated from message artifacts.store.v1.GetArtifactRevisionDownloadUrlRequest
 */
export type GetArtifactRevisionDownloadUrlRequest = Message<"artifacts.store.v1.GetArtifactRevisionDownloadUrlRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message artifacts.store.v1.GetArtifactRevisionDownloadUrlRequest.
 * Use `create(GetArtifactRevisionDownloadUrlRequestSchema)` to create a new message.
 */
export const GetArtifactRevisionDownloadUrlRequestSchema: GenMessage<GetArtifactRevisionDownloadUrlRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 16);

/**
 * @generated from message artifacts.store.v1.GetArtifactRevisionDownloadUrlResponse
 */
export type GetArtifactRevisionDownloadUrlResponse = Message<"artifacts.store.v1.GetArtifactRevisionDownloadUrlResponse"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message artifacts.store.v1.GetArtifactRevisionDownloadUrlResponse.
 * Use `create(GetArtifactRevisionDownloadUrlResponseSchema)` to create a new message.
 */
export const GetArtifactRevisionDownloadUrlResponseSchema: GenMessage<GetArtifactRevisionDownloadUrlResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 17);

/**
 * @generated from message artifacts.store.v1.GetArtifactRevisionRequest
 */
export type GetArtifactRevisionRequest = Message<"artifacts.store.v1.GetArtifactRevisionRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message artifacts.store.v1.GetArtifactRevisionRequest.
 * Use `create(GetArtifactRevisionRequestSchema)` to create a new message.
 */
export const GetArtifactRevisionRequestSchema: GenMessage<GetArtifactRevisionRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 18);

/**
 * @generated from message artifacts.store.v1.GetArtifactRevisionResponse
 */
export type GetArtifactRevisionResponse = Message<"artifacts.store.v1.GetArtifactRevisionResponse"> & {
  /**
   * @generated from field: bytes file_content = 1;
   */
  fileContent: Uint8Array;
};

/**
 * Describes the message artifacts.store.v1.GetArtifactRevisionResponse.
 * Use `create(GetArtifactRevisionResponseSchema)` to create a new message.
 */
export const GetArtifactRevisionResponseSchema: GenMessage<GetArtifactRevisionResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 19);

/**
 * @generated from message artifacts.store.v1.UploadArtifactRequest
 */
export type UploadArtifactRequest = Message<"artifacts.store.v1.UploadArtifactRequest"> & {
  /**
   * @generated from field: string file_name = 1;
   */
  fileName: string;

  /**
   * @generated from field: bytes file_content = 2;
   */
  fileContent: Uint8Array;

  /**
   * @generated from field: optional string company_id = 3;
   */
  companyId?: string;

  /**
   * @generated from field: artifacts.v1.DocumentSource source = 4;
   */
  source: DocumentSource;

  /**
   * @generated from field: optional artifacts.store.v1.CategoryMetadata category_metadata = 5;
   */
  categoryMetadata?: CategoryMetadata;

  /**
   * @generated from field: optional bool is_encrypted = 6;
   */
  isEncrypted?: boolean;

  /**
   * @generated from field: optional string password = 7;
   */
  password?: string;

  /**
   * @generated from field: optional string external_id = 8;
   */
  externalId?: string;

  /**
   * @generated from field: optional companycatalog.v1.Platform platform = 9;
   */
  platform?: Platform;
};

/**
 * Describes the message artifacts.store.v1.UploadArtifactRequest.
 * Use `create(UploadArtifactRequestSchema)` to create a new message.
 */
export const UploadArtifactRequestSchema: GenMessage<UploadArtifactRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 20);

/**
 * @generated from message artifacts.store.v1.UploadArtifactResponse
 */
export type UploadArtifactResponse = Message<"artifacts.store.v1.UploadArtifactResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message artifacts.store.v1.UploadArtifactResponse.
 * Use `create(UploadArtifactResponseSchema)` to create a new message.
 */
export const UploadArtifactResponseSchema: GenMessage<UploadArtifactResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 21);

/**
 * @generated from message artifacts.store.v1.UploadArtifactRevisionRequest
 */
export type UploadArtifactRevisionRequest = Message<"artifacts.store.v1.UploadArtifactRevisionRequest"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;

  /**
   * @generated from field: bytes file_content = 2;
   */
  fileContent: Uint8Array;
};

/**
 * Describes the message artifacts.store.v1.UploadArtifactRevisionRequest.
 * Use `create(UploadArtifactRevisionRequestSchema)` to create a new message.
 */
export const UploadArtifactRevisionRequestSchema: GenMessage<UploadArtifactRevisionRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 22);

/**
 * @generated from message artifacts.store.v1.UploadArtifactRevisionResponse
 */
export type UploadArtifactRevisionResponse = Message<"artifacts.store.v1.UploadArtifactRevisionResponse"> & {
};

/**
 * Describes the message artifacts.store.v1.UploadArtifactRevisionResponse.
 * Use `create(UploadArtifactRevisionResponseSchema)` to create a new message.
 */
export const UploadArtifactRevisionResponseSchema: GenMessage<UploadArtifactRevisionResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 23);

/**
 * @generated from message artifacts.store.v1.CategoryMetadata
 */
export type CategoryMetadata = Message<"artifacts.store.v1.CategoryMetadata"> & {
  /**
   * @generated from field: string category = 1;
   */
  category: string;

  /**
   * @generated from field: string subcategory = 2;
   */
  subcategory: string;
};

/**
 * Describes the message artifacts.store.v1.CategoryMetadata.
 * Use `create(CategoryMetadataSchema)` to create a new message.
 */
export const CategoryMetadataSchema: GenMessage<CategoryMetadata> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 24);

/**
 * @generated from message artifacts.store.v1.RetryArtifactRequest
 */
export type RetryArtifactRequest = Message<"artifacts.store.v1.RetryArtifactRequest"> & {
  /**
   * @generated from field: string artifact_id = 1;
   */
  artifactId: string;
};

/**
 * Describes the message artifacts.store.v1.RetryArtifactRequest.
 * Use `create(RetryArtifactRequestSchema)` to create a new message.
 */
export const RetryArtifactRequestSchema: GenMessage<RetryArtifactRequest> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 25);

/**
 * @generated from message artifacts.store.v1.RetryArtifactResponse
 */
export type RetryArtifactResponse = Message<"artifacts.store.v1.RetryArtifactResponse"> & {
};

/**
 * Describes the message artifacts.store.v1.RetryArtifactResponse.
 * Use `create(RetryArtifactResponseSchema)` to create a new message.
 */
export const RetryArtifactResponseSchema: GenMessage<RetryArtifactResponse> = /*@__PURE__*/
  messageDesc(file_artifacts_store_v1_store_service, 26);

/**
 * @generated from service artifacts.store.v1.OrgArtifactStoreService
 */
export const OrgArtifactStoreService: GenService<{
  /**
   * @generated from rpc artifacts.store.v1.OrgArtifactStoreService.GetArtifactPreviewUrl
   */
  getArtifactPreviewUrl: {
    methodKind: "unary";
    input: typeof GetArtifactPreviewUrlRequestSchema;
    output: typeof GetArtifactPreviewUrlResponseSchema;
  },
  /**
   * GetArtifactDownloadUrl returns a presigned link that saves the file rather
   * than opening it. Separate from GetArtifactPreviewUrl because the only
   * difference is the object's content-disposition, and the two are wanted in
   * different places -- the bytes never pass through our servers either way.
   *
   * @generated from rpc artifacts.store.v1.OrgArtifactStoreService.GetArtifactDownloadUrl
   */
  getArtifactDownloadUrl: {
    methodKind: "unary";
    input: typeof GetArtifactDownloadUrlRequestSchema;
    output: typeof GetArtifactDownloadUrlResponseSchema;
  },
  /**
   * @generated from rpc artifacts.store.v1.OrgArtifactStoreService.UploadArtifact
   */
  uploadArtifact: {
    methodKind: "unary";
    input: typeof UploadArtifactRequestSchema;
    output: typeof UploadArtifactResponseSchema;
  },
  /**
   * @generated from rpc artifacts.store.v1.OrgArtifactStoreService.RetryArtifact
   */
  retryArtifact: {
    methodKind: "unary";
    input: typeof RetryArtifactRequestSchema;
    output: typeof RetryArtifactResponseSchema;
  },
  /**
   * @generated from rpc artifacts.store.v1.OrgArtifactStoreService.DeleteOrgArtifact
   */
  deleteOrgArtifact: {
    methodKind: "unary";
    input: typeof DeleteOrgArtifactRequestSchema;
    output: typeof DeleteOrgArtifactResponseSchema;
  },
  /**
   * @generated from rpc artifacts.store.v1.OrgArtifactStoreService.DownloadOrgArtifact
   */
  downloadOrgArtifact: {
    methodKind: "unary";
    input: typeof DownloadOrgArtifactRequestSchema;
    output: typeof DownloadOrgArtifactResponseSchema;
  },
  /**
   * DownloadArtifactBundle streams the selected org artifacts as one zip.
   * Server-streaming so the archive is never held in memory: the handler copies
   * each object straight from object storage into the stream.
   *
   * @generated from rpc artifacts.store.v1.OrgArtifactStoreService.DownloadArtifactBundle
   */
  downloadArtifactBundle: {
    methodKind: "server_streaming";
    input: typeof DownloadArtifactBundleRequestSchema;
    output: typeof DownloadArtifactBundleResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_artifacts_store_v1_store_service, 0);

/**
 * @generated from service artifacts.store.v1.ArtifactStoreService
 */
export const ArtifactStoreService: GenService<{
  /**
   * @generated from rpc artifacts.store.v1.ArtifactStoreService.GetArtifactRevisionPreviewUrl
   */
  getArtifactRevisionPreviewUrl: {
    methodKind: "unary";
    input: typeof GetArtifactRevisionPreviewUrlRequestSchema;
    output: typeof GetArtifactRevisionPreviewUrlResponseSchema;
  },
  /**
   * @generated from rpc artifacts.store.v1.ArtifactStoreService.GetArtifactRevisionDownloadUrl
   */
  getArtifactRevisionDownloadUrl: {
    methodKind: "unary";
    input: typeof GetArtifactRevisionDownloadUrlRequestSchema;
    output: typeof GetArtifactRevisionDownloadUrlResponseSchema;
  },
  /**
   * @generated from rpc artifacts.store.v1.ArtifactStoreService.GetArtifactRevision
   */
  getArtifactRevision: {
    methodKind: "unary";
    input: typeof GetArtifactRevisionRequestSchema;
    output: typeof GetArtifactRevisionResponseSchema;
  },
  /**
   * @generated from rpc artifacts.store.v1.ArtifactStoreService.UploadArtifactRevision
   */
  uploadArtifactRevision: {
    methodKind: "unary";
    input: typeof UploadArtifactRevisionRequestSchema;
    output: typeof UploadArtifactRevisionResponseSchema;
  },
  /**
   * @generated from rpc artifacts.store.v1.ArtifactStoreService.UpdateArtifactSubcategory
   */
  updateArtifactSubcategory: {
    methodKind: "unary";
    input: typeof UpdateArtifactSubcategoryRequestSchema;
    output: typeof UpdateArtifactSubcategoryResponseSchema;
  },
  /**
   * @generated from rpc artifacts.store.v1.ArtifactStoreService.SetArtifactMisclassification
   */
  setArtifactMisclassification: {
    methodKind: "unary";
    input: typeof SetArtifactMisclassificationRequestSchema;
    output: typeof SetArtifactMisclassificationResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_artifacts_store_v1_store_service, 1);

